
import React from "react";
import { NumericInputProps } from "./types";
import SliderDisplay from "./SliderDisplay";
import InputDisplay from "./InputDisplay";
import { useNumericInputState } from "./useNumericInputState";
import AnimatedWrapper from "./AnimatedWrapper";

export const NumericInput: React.FC<NumericInputProps> = ({
  label,
  description,
  value,
  onChange,
  formatValue,
  parseValue,
  min = Number.MIN_SAFE_INTEGER,
  max = Number.MAX_SAFE_INTEGER,
  step = 1,
  showSlider = false,
  sliderStep,
  suffix = "",
  prefix = "",
  allowNegative = false,
  decimalPlaces,
  disabled = false,
  className = "",
  inputClassName = "",
  labelClassName = "",
  descriptionClassName = "text-xs text-homebuyer-gray mt-1",
  showMinMax = true,
  ...props
}) => {
  const {
    inputValue,
    isAnimating,
    handleInputChange,
    handleBlur,
    handleSelectionCheck,
    handleSliderChange
  } = useNumericInputState({
    value,
    onChange,
    formatValue,
    parseValue,
    prefix,
    suffix,
    min,
    max,
    allowNegative,
    decimalPlaces
  });

  return (
    <div className={`space-y-2 ${className}`}>
      <AnimatedWrapper isAnimating={isAnimating}>
        <InputDisplay
          label={label}
          inputValue={inputValue}
          handleInputChange={handleInputChange}
          handleBlur={handleBlur}
          disabled={disabled}
          inputClassName={`${inputClassName} ${isAnimating ? 'border-primary/70' : ''}`}
          labelClassName={labelClassName}
          description={!showSlider ? description : undefined}
          descriptionClassName={descriptionClassName}
          onMouseUp={handleSelectionCheck}
          onKeyUp={handleSelectionCheck}
          onFocus={(e: React.FocusEvent<HTMLInputElement>) => e.target.select()}
          {...props}
        />
      </AnimatedWrapper>
      
      {showSlider && (
        <AnimatedWrapper isAnimating={isAnimating} className={isAnimating ? 'scale-[1.02]' : ''}>
          <SliderDisplay
            value={value}
            min={min}
            max={max}
            step={sliderStep || step}
            disabled={disabled}
            showMinMax={showMinMax}
            formatValue={formatValue}
            onChange={handleSliderChange}
          />
        </AnimatedWrapper>
      )}
      
      {showSlider && description && (
        <p className={descriptionClassName}>{description}</p>
      )}
    </div>
  );
};
